import { PropsWithChildren, ReactNode, useCallback } from 'react';

import { Box, SelectBox, Text, u } from '@ui';

import * as css from './Select.css';

type SelectProps<T> = {
    onSelect?: (value?: T) => void;
    selected?: boolean;
    value?: T;
    action?: ReactNode;
    icon?: ReactNode;
    info?: ReactNode;
};

const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

export const Select = <T,>({
    children,
    selected,
    onSelect,
    value,
    action,
    icon,
    info,
}: PropsWithChildren<SelectProps<T>>) => {
    const onClick = useCallback(() => onSelect?.(value), [onSelect, value]);
    return (
        <div className={css.select} onClick={onClick}>
            <SelectBox size="small" selected={selected} />
            <div className={css.row}>
                <div className={css.group}>
                    {icon}
                    <Box
                        display="flex"
                        flexDirection="column"
                        ml={u(1)}
                        alignItems="flex-start"
                        flexGrow={1}
                        gap={u(0.5)}
                    >
                        <Text variant="h3">{children}</Text>
                        {info && (
                            <Text variant="small" color="muted" fontSize={12}>
                                {info}
                            </Text>
                        )}
                    </Box>
                </div>

                <div onClick={stopPropagation}>{action}</div>
            </div>
        </div>
    );
};
